import { render, staticRenderFns } from "./SimbarFooter.vue?vue&type=template&id=22155e7e&scoped=true&"
import script from "./SimbarFooter.vue?vue&type=script&lang=js&"
export * from "./SimbarFooter.vue?vue&type=script&lang=js&"
import style0 from "./SimbarFooter.vue?vue&type=style&index=0&id=22155e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22155e7e",
  null
  
)

export default component.exports